import {Link} from 'react-router-dom';
import {VStack} from '@astryxdesign/core/VStack';
import {HStack} from '@astryxdesign/core/HStack';
import {Text} from '@astryxdesign/core/Text';
import {Button} from '@astryxdesign/core/Button';
import {Spinner} from '@astryxdesign/core/Spinner';
import {tenantPath} from '@/lib/tenant/resolve';
import type {ChatMessage} from '@/hooks/useAssistantChat';

/** Пузыри переписки: ответы помощника могут нести кнопки с окнами и быстрые ответы. */
export function ChatBubbles({
  slug,
  messages,
  pending,
  onChoice,
}: {
  slug: string;
  messages: ChatMessage[];
  pending: boolean;
  onChoice: (text: string) => void;
}) {
  return (
    <VStack gap={2}>
      {messages.map((m, index) => (
        <VStack
          key={`${m.role}-${index}`}
          gap={2}
          className={
            m.role === 'user'
              ? 'max-w-[85%] self-end rounded-2xl border border-tenant-accent tenant-accent-soft px-3 py-2'
              : 'max-w-[92%] self-start rounded-2xl border border-border bg-surface px-3 py-2'
          }
        >
          <Text type="body">{m.content}</Text>
          {m.slots && m.slots.length > 0 && m.serviceId ? (
            <HStack gap={2} wrap="wrap">
              {m.slots.map((slot) => (
                <Link
                  key={slot.iso}
                  to={`${tenantPath(slug, 'book')}?service=${encodeURIComponent(m.serviceId ?? '')}&slot=${encodeURIComponent(slot.iso)}`}
                  className="rounded-full border border-tenant-accent bg-tenant-accent px-3 py-1.5 text-white"
                >
                  <Text type="supporting" color="inherit" weight="semibold" hasTabularNumbers>
                    {slot.label}
                  </Text>
                </Link>
              ))}
            </HStack>
          ) : null}
          {m.choices && m.choices.length > 0 ? (
            <HStack gap={2} wrap="wrap">
              {m.choices.map((choice) => (
                <Button key={choice} label={choice} variant="secondary" size="sm" onClick={() => onChoice(choice)} />
              ))}
            </HStack>
          ) : null}
        </VStack>
      ))}
      {pending ? <Spinner /> : null}
    </VStack>
  );
}
